export default "__VITE_ASSET__BERkFgkM__"